'use client';

import { AnimatePresence, motion } from 'framer-motion';

import { EventManagerQuestion } from '@/types/eventManagerQuestion';
import { EventTicketType } from '@/types/eventTicketType';

import EventPageBuyTicketSectionContent from './EventPageBuyTicketSectionContent';

interface EventPageBuyTicketSectionProps {
  ticketCount: number;
  placeId: string;
  userToken?: string;
  eventManagerQuestions: EventManagerQuestion[];
  eventTicketTypes: EventTicketType[];
}

export default function EventPageBuyTicketSection({
  ticketCount,
  placeId,
  userToken,
  eventManagerQuestions,
  eventTicketTypes,
}: EventPageBuyTicketSectionProps) {
  return (
    <>
      {/* Desktop */}
      <div className='hidden text-white-filled-default sm:block'>
        <AnimatePresence>
          {ticketCount > 0 && (
            <motion.div
              className='relative z-50 w-full'
              initial={{ opacity: 0.1, y: '10%', scale: 0.9 }}
              animate={{ opacity: 1, y: '0', scale: 1 }}
              exit={{ opacity: 0.1, y: '10%', scale: 0.9 }}
              transition={{ duration: 0.2 }}
            >
              <EventPageBuyTicketSectionContent
                placeId={placeId}
                ticketCount={ticketCount}
                eventManagerQuestions={eventManagerQuestions}
                userToken={userToken}
                eventTicketTypes={eventTicketTypes}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {/* Mobile */}
      <div className='text-white-filled-default sm:hidden'>
        <AnimatePresence>
          {ticketCount > 0 && (
            <motion.div
              className='fixed bottom-0 left-0 z-50 mx-auto w-full max-w-md md:left-1/2'
              initial={{ opacity: 0, y: '100%' }}
              animate={{ opacity: 1, y: '0' }}
              exit={{ opacity: 0, y: '100%' }}
            >
              <EventPageBuyTicketSectionContent
                placeId={placeId}
                ticketCount={ticketCount}
                eventManagerQuestions={eventManagerQuestions}
                userToken={userToken}
                eventTicketTypes={eventTicketTypes}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
}
